import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'; 
import cl from './ImageModal.module.css'
import Photo from "../../../../assets/Icon/Photo";
import PhotoCamera from "../../../../assets/Icon/PhotoCamera";
import DownloadIcon from "../../../../assets/Icon/Download";
import ImageUploader from '../../../UI/ImageUploader/ImageUploader';
import axios from 'axios';
import automobyApi, { baseFileURL } from '../../../../Api';
import { useAuth } from '../../../../providers/authProvider';
import { AppContext } from '../../../../providers/appProvider';
import { useTranslation } from 'react-i18next';

const ImageModal = ({ carService, defaultCar, isBtn }) => {
    const {t} = useTranslation();
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingImages, setLoadingImages] = useState([])
    const [arrivalImages, setArrivalImages] = useState([])
    const [buyImages, setBuyImages] = useState([])
    const {session} = useAuth(AppContext)
    const { appState, app } = useContext(AppContext);

    useEffect(() => {
        setLoadingImages(defaultCar.images_obj.loading) 
        setArrivalImages(defaultCar.images_obj.arrival) 
        setBuyImages(defaultCar.images_obj.buy) 

    }, [])

    const uploadImage = async (kind, acceptedFiles) => {
       
        const formData = new FormData();

        acceptedFiles.forEach((file) => {
            formData.append('images[]', file, file.name);
        });

        formData.append('carid', defaultCar.id.toString());
        formData.append('kind', kind);

        try {

            const response = await automobyApi.post("/image/upload", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setLoadingImages(response.data.loading)
            setArrivalImages(response.data.arrival)
            setBuyImages(response.data.buy)
            carService.fetchCars()
        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }

    const deleteImage = async (kind, image) => {
        
        const requestData = {
            car_id: defaultCar.id,
            kind: kind,
            image: image
        };
 

        try {
            const response = await automobyApi.post("/image/delete", requestData)

            setLoadingImages(response.data.loading)
            setArrivalImages(response.data.arrival)
            setBuyImages(response.data.buy)

        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }

    const moveImages = (carId, kind, imageArray) => {

    }


    let mainImage;

    if (buyImages[0]) {
        mainImage = <img src={baseFileURL + buyImages[0]} alt="" />;
    } else if (loadingImages[0]) {
        mainImage = <img src={baseFileURL+ loadingImages[0]} alt="" />;
    } else if (arrivalImages[0]) {
        mainImage = <img src={baseFileURL + arrivalImages[0]} alt="" />;
    } else {
        mainImage = <Photo/>;
    }

    const downloadImage = (name) => {
        carService.downloadFile(defaultCar.id, name)
    }



    return (
        <>
             
             {isBtn ? 
                <span className={cl.imgBTN} onClick={() => setIsModalOpen(true)} >
                    <PhotoCamera />
                    {t("Images")}
                </span>
            : 
                <div className={ cl.imageBox } > 
                    <div className={cl.imgCar} onClick={() => setIsModalOpen(true)} >
                        {mainImage}
                    </div> 
                </div> 
            }
              
   

        <Modal size="large" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

            <div className={cl.modalHead} >
                <h3>
                    <span className={cl.iconHead} ><PhotoCamera /></span> {t("Images")}
                </h3>
            </div>

            <div style={{ position: 'relative', display: 'block' }}>
                <div className={ cl.threeBox }>

                    <div className={ cl.col }>
                    <span className={ cl.downBTN }onClick={() => downloadImage("buy")}>  <DownloadIcon/> {t('Download')}</span>

                        <ImageUploader images={buyImages}
                            uploadImage={uploadImage}
                            deleteImage={deleteImage}
                            title="ყიდვის სურათები" 
                            kind="buy"
                            disabled={!app.hasPermission("PICTURE_ADD")}
                            ></ImageUploader>
                    </div>

                    <div className={ cl.col }>
                        <span className={ cl.downBTN } onClick={() => downloadImage("loading")}>  <DownloadIcon/> {t('Download')}</span>

                        <ImageUploader images={loadingImages}
                        uploadImage={uploadImage}
                        deleteImage={deleteImage}
                        title="ჩატვირთვის სურათები" 
                        kind="loading"
                        disabled={!app.hasPermission("PICTURE_ADD")}
                        ></ImageUploader> 
                    </div>
                    
                    <div className={ cl.col }>
                        
                        <span className={ cl.downBTN } onClick={() => downloadImage("arrival")}> <DownloadIcon/> {t('Download')}</span>

                        <ImageUploader 
                            images={arrivalImages}
                            uploadImage={uploadImage}
                            deleteImage={deleteImage}
                            title="ჩამოსვლის სურათები" 
                            kind="arrival"
                            disabled={!app.hasPermission("PICTURE_ADD")}
                            > 
                        </ImageUploader>
                    </div>
                    
                
                    
                </div>
            </div>

            </Modal>


        </>
    );
};

export default ImageModal;